import * as actionTypes from '../actions/types';


const initialState = {
    categoryLoader: false,
    categories: [],
    subCategoryLoader: false,
    subCategories: [],
    getCountriesLoader: false,
    countries: [],
    getSatesLoader: false,
    states: [],
    getCitiesLoader: false,
    Cities: [],
    getUnitOfMeasuresLoader: false,
    unitOfMeasures: [],
    addPropertyLoader: false,
    addPropertyData: [],
    uploadPropertyImageLoader: false,
    uploadPropertyImageData: [],
    getAllPropertiesLoader: false,
    likePropertyData: [],
    likePropertyLoader: false,
    unlikePropertyData: [],
    unlikePropertyLoader: false,
    allProperties: [],
    suggestedLocationsLoader: false,
    suggestedLocations: [],
    PropertyCount:'',
    amenities:[],
    amenitiesLoader:false,
    girePropertyLoader:false,
    gireProperties:[],
    error: {}
};

function propertyReducer(state = initialState, action) {
    const {type, payload} = action;

    switch (type) {
        case actionTypes.GET_PROPERTY_CATEGORY_LOADER:
            return {
                ...state,
                categoryLoader: payload,
            };
        case actionTypes.GET_PROPERTY_CATEGORY:
            return {
                ...state,
                categories: payload,

            };
        case actionTypes.GET_PROPERTY_SUB_CATEGORY_LOADER:
            return {
                ...state,
                subCategoryLoader: payload,
            };
        case actionTypes.GET_PROPERTY_SUB_CATEGORY:
            return {
                ...state,
                subCategories: payload,

            };
        // GET COUNTRIES
        case actionTypes.GET_COUNTRIES_LOADER:
            return {
                ...state,
                getCountriesLoader: payload,

            };
        case actionTypes.GET_COUNTRIES:
            return {
                ...state,
                countries: payload,

            };
        // GET STATES
        case actionTypes.GET_STATES_LOADER:
            return {
                ...state,
                getSatesLoader: payload,

            };
        case actionTypes.GET_STATES:
            return {
                ...state,
                states: payload,

            };
        // GET CITIES
        case actionTypes.GET_CITIES_LOADER:
            return {
                ...state,
                getCitiesLoader: payload,

            };
        case actionTypes.GET_CITIES:
            return {
                ...state,
                cities: payload,

            };
        // GET UNIT_OF_MEASURES
        case actionTypes.GET_UNIT_OF_MEASURES_LOADER:
            return {
                ...state,
                getUnitOfMeasuresLoader: payload,

            };
        // GET AMENITIES
        case actionTypes.GET_AMENITIES_LOADER:
            return {
                ...state,
                amenitiesLoader: payload,

            };
        case actionTypes.GET_AMENITIES:
            return {
                ...state,
                amenities: payload,

            };
        case actionTypes.GET_UNIT_OF_MEASURES:
            return {
                ...state,
                unitOfMeasures: payload,

            };
        // ADD Property
        case actionTypes.ADD_PROPERTY_LOADER:
            return {
                ...state,
                addPropertyLoader: payload,

            };
        case actionTypes.ADD_PROPERTY:
            return {
                ...state,
                addPropertyData: payload,

            };
        // Get Property Details
        case actionTypes.GET_PROPERTY_DETAILS_LOADER:
            return {
                ...state,
                getPropertyDetailsLoader: payload,

            };
        case actionTypes.GET_PROPERTY_DETAILS:
            return {
                ...state,
                getPropertyDetails: payload,

            };
        // UPLOAD Property Image
        case actionTypes.UPLOAD_PROPERTY_IMAGE_LOADER:
            return {
                ...state,
                uploadPropertyImageLoader: payload,

            };
        case actionTypes.UPLOAD_PROPERTY_IMAGE:
            return {
                ...state,
                uploadPropertyImageData: payload,

            };
        case actionTypes.GET_SUGGESTED_LOCATION_LOADER:
            return {
                ...state,
                suggestedLocationsLoader: payload
            };
        case actionTypes.GET_SUGGESTED_LOCATIONS:
            return {
                ...state,
                suggestedLocations: payload,
            };
        case actionTypes.LIKE_PROPERTY_LOADER:
            return {
                ...state,
                likePropertyLoader: payload,

            };
        case actionTypes.LIKE_PROPERTY_DATA:
            return {
                ...state,
                allProperties: state.allProperties.map(data => (data._id === payload._id) ? {
                    ...data,
                    likes: payload.likes,
                } : data)
            };


        case actionTypes.UNLIKE_PROPERTY_LOADER:
            return {
                ...state,
                unlikePropertyLoader: payload,

            };
        case actionTypes.UNLIKE_PROPERTY_DATA:
            return {
                ...state,
                allProperties: state.allProperties.map(data => (data._id === payload._id) ? {
                    ...data,
                    likes: payload.likes,
                } : data)

            };
        case actionTypes.REMOVE_PROPERTIES:
            return {
                ...state,
                allProperties: payload,
            };
        // GET All Properties List
        case actionTypes.GET_ALL_PROPERTIES_LIST_LOADER:
            return {
                ...state,
                getAllPropertiesLoader: payload,

            };
        case actionTypes.GET_ALL_PROPERTIES_LIST:
            return {
                ...state,
                allProperties: [...state.allProperties, ...payload],
            };

        case actionTypes.GET_PROPERTIES_COUNT:
            return {
                ...state,
                PropertyCount: payload,
            };
        //ADD_UPDATE  Property To Global India Realestate
        case actionTypes.ADD_PROPERTY_TO_GIRE_LOADER:
            return {
                ...state,
                girePropertyLoader: payload,
            };
        case actionTypes.ADD_PROPERTY_TO_GIRE:
            return {
                ...state,
                gireProperties: payload,
            };

        default:
            return state;
    }
}

export default propertyReducer;
